import {setGlobalOptions} from '../loader-utils/option-utils';

/**
 * Set global loader options
 * @param options
 */
export function setLoaderOptions(options: object): void {
  setGlobalOptions(options);
}
